enum ContractRefundStatusCode {
  OPEN = 'OPEN',
  PROCESSING = 'PROCESSING',
  APPROVED = 'APPROVED',
}

export default ContractRefundStatusCode;
export type VerifyContractRefundStatusCode = Utils.VerifyExtends<
  Model.Enum.ContractRefundStatusCode,
  Utils.ValueOf<typeof ContractRefundStatusCode>
>;
